import { CSSResultGroup, TemplateResult, html } from 'lit';
import {
  OutlineElement,
  SlotsController,
  LightDomStyles,
} from '@phase2/outline-core';
import { customElement } from 'lit/decorators.js';
import componentStyles from '../outline-sidebar-block/outline-sidebar-block.css.lit';
import componentLightDomStyles from '../outline-sidebar-block/outline-sidebar-block-light-dom.css.lit';

/**
 * The Sidebar Block component
 * @element outline-sidebar-block
 *
 * @slot heading - heading (outline-heading-baseline)
 * @slot default - block content
 */
@customElement('outline-sidebar-block')
export class OutlineSidebarBlock extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotsController(this);

  lightDomStyles = new LightDomStyles(
    this,
    componentLightDomStyles,
    this.tagName.toLowerCase()
  );

  render(): TemplateResult {
    return html`
      <div class="sidebar-block">
        ${this.slots.conditionalSlot('heading', false)}
        <hr class="rule" />
        <slot></slot>
      </div>
    `;
  }
}
